import { ApolloClient, createHttpLink, DefaultOptions, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { RetryLink } from '@apollo/client/link/retry';
import { COOKIE_DEVICE_ID, COOKIE_SOURCE } from 'common/cookies/Cookies';
import { GqlRequestSource } from 'common/GqlRequestSource';
import { getGqlApiUrl } from 'utils/environment-util';

const apiUrl = getGqlApiUrl();

const httpLink = createHttpLink({
  uri: apiUrl,
  credentials: 'include', // allows cookies
});

const retryLink = new RetryLink({
  delay: {
    initial: 250,
    max: 2500,
    jitter: true,
  },
  attempts: {
    max: 3,
    retryIf: (error: any) => {
      const doNotRetryCodes = [500, 400];
      return !!error && !doNotRetryCodes.includes(error.statusCode);
    },
  },
});

// TODO: Gil Note: Restore clientSchemaVersionLink
// const clientSchemaVersionLink = setContext((_, { headers }) => {
//   if (!BUILD_TIMESTAMP) {
//     return {
//       headers,
//     };
//   }
//
//   return {
//     headers: {
//       ...headers,
//       'x-version': BUILD_TIMESTAMP,
//     },
//   };
// });

// TODO: Gil Note: Try to restore dataDog
// const datadogLink = setContext((_, { headers }) => {
//   const datadogSessionId = window.DD_RUM?.getInternalContext()?.session_id;
//
//   if (!datadogSessionId) {
//     return {
//       headers,
//     };
//   }
//
//   return {
//     headers: {
//       ...headers,
//       'x-datadog-url': `https://app.datadoghq.com/rum/replay/sessions/${datadogSessionId}`,
//     },
//   };
// });

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
};

// interface CreateGqlClientOptions {
//   source: GqlRequestSource;
//   browserTrackerId: string;
// }

export type GqlClient = ApolloClient<NormalizedCacheObject>;

export function createGqlClient(browserTrackerId: string): GqlClient {
  const browserTrackerLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        [COOKIE_DEVICE_ID]: browserTrackerId,
        [COOKIE_SOURCE]: GqlRequestSource.SHEF_NEXT,
      },
    };
  });

  const link = browserTrackerLink.concat(retryLink).concat(httpLink);

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
    defaultOptions,
  });
}

const client = createGqlClient('nextjs-static-site');
export default client;
